/**document.addEventListener("DOMContentLoaded", function () {
  // Select all <details> elements
  const detailsElements = document.querySelectorAll("details");
  const header = document.querySelector(".header");

  // Function to update header background based on <details> elements
  function updateHeaderBackground() {
    let isOpen = false;

    // Check if any <details> element is open
    detailsElements.forEach((details) => {
      if (details.hasAttribute("open")) {
        isOpen = true;
      }
    });

    // Update header background based on whether any <details> is open
    if (isOpen) {
      header.classList.add("sk-menu-open");
    } else {
      header.classList.remove("sk-menu-open");
    }
  }

  // Initial check
  updateHeaderBackground();

  // Add event listeners to all <details> elements
  detailsElements.forEach((details) => {
    details.addEventListener("toggle", updateHeaderBackground);
  });

  const scrollThreshold = 10; // Set this to the scroll position where you want to change the background

  function onScroll() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add("sk-scrolled");
    } else {
      header.classList.remove("sk-scrolled");
    }
  }

  // Add scroll event listener
  window.addEventListener("scroll", onScroll);

  // Initial check in case of page load with scroll position already set
  onScroll();
});
**/

document.addEventListener("DOMContentLoaded", function () {
  // Select all <details> elements
  const detailsElements = document.querySelectorAll("details");
  const header = document.querySelector(".site-header2");

  // Function to update header background based on <details> elements
  function updateHeaderBackground() {
    let isOpen = false;

    // Check if any <details> element is open
    detailsElements.forEach((details) => {
      if (details.hasAttribute("open")) {
        isOpen = true;
      }
    });

    // Update header background based on whether any <details> is open
    if (isOpen) {
      header.classList.add("sk-menu-open");
    } else {
      header.classList.remove("sk-menu-open");
    }
  }

  // Initial check
  updateHeaderBackground();

  // Add event listeners to all <details> elements
  detailsElements.forEach((details) => {
    details.addEventListener("toggle", updateHeaderBackground);
  });

  const scrollThreshold = 10; // Set this to the scroll position where you want to change the background

  function onScroll() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add("sk-scrolled");
    } else {
      header.classList.remove("sk-scrolled");
    }
  }

  // Add scroll event listener
  //window.addEventListener("scroll", onScroll);

  // Initial check in case of page load with scroll position already set
  //onScroll();

  // Get all the offcanvas toggles
  const offcanvasToggles = document.querySelectorAll(".sk-menu-item");

  // Keep track of the currently active toggle
  let activeToggle = null;

  var offcanvasElements = [
    document.getElementById("collections"),
    document.getElementById("news"),
    document.getElementById("lookbook"),
    document.getElementById("shopcategory"),
  ];

  var headerElement = document.querySelector(".site-header2");

  // Initialize Bootstrap offcanvas instances for manual control
  const offcanvasInstances = offcanvasElements.map(function (offcanvasElement) {
    return new bootstrap.Offcanvas(offcanvasElement);
  });

  // Function to show offcanvas
  function showOffcanvas(offcanvasElement) {
    const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (offcanvasInstance) {
      offcanvasInstance.show();
      // Add 'sk-menu-open' class to header when offcanvas is shown
      headerElement.classList.add("sk-menu-open");
    }
  }

  // Function to hide offcanvas
  function hideOffcanvas(offcanvasElement) {
    const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (offcanvasInstance) {
      offcanvasInstance.hide();
      // Remove 'sk-menu-open' class from header when offcanvas is hidden
      //headerElement.classList.remove("sk-menu-open");
    }
  }

  // Add hover event to show/hide offcanvas on hover for toggles
  offcanvasToggles.forEach(function (toggle) {
    const offcanvasTargetId = toggle.getAttribute("data-bs-target");
    const offcanvasElement = document.querySelector(offcanvasTargetId);

    // On mouseenter (hover) show the offcanvas
    toggle.addEventListener("mouseenter", function () {
      showOffcanvas(offcanvasElement);

      // Remove 'active' class from previously active toggle
      if (activeToggle && activeToggle !== toggle) {
        activeToggle.classList.remove("active");
      }

      // Add 'active' class to the current toggle
      toggle.classList.add("active");
      activeToggle = toggle; // Keep track of the active toggle
    });

    // Add mouseleave event to hide the offcanvas only if mouse is not over the offcanvas content
    toggle.addEventListener("mouseleave", function () {
      setTimeout(() => {
        // Check if both the toggle and the offcanvas are not hovered
        if (!offcanvasElement.matches(":hover") && !toggle.matches(":hover")) {
          hideOffcanvas(offcanvasElement);
          //headerElement.classList.remove("sk-menu-open");
          toggle.classList.remove("active"); // Remove 'active' class when offcanvas is hidden
        }
      }, 100);
    });
  });

  // Add hover event to prevent hiding offcanvas when hovering over the offcanvas content
  offcanvasElements.forEach(function (offcanvasElement) {
    offcanvasElement.addEventListener("mouseenter", function () {
      // Keep it open
      showOffcanvas(offcanvasElement);
    });

    // On mouseleave, hide the offcanvas if not hovering over the toggle anymore
    offcanvasElement.addEventListener("mouseleave", function () {
      setTimeout(() => {
        const toggle = document.querySelector(
          `[data-bs-target="#${offcanvasElement.id}"]`
        );
        if (!offcanvasElement.matches(":hover") || !toggle.matches(":hover")) {
          hideOffcanvas(offcanvasElement);
          headerElement.classList.remove("sk-menu-open");

          if (toggle) toggle.classList.remove("active"); // Remove 'active' class on hide
        }
      }, 100);
    });
  });

  // Get all collection links
  const smls = document.querySelectorAll(".sk-menu-link");

  // Add hover event to each link
  smls.forEach((link) => {
    link.addEventListener("mouseenter", function () {
      const imgSrc = this.getAttribute("data-img");

      // Find the closest parent with class 'offcanvas', then find the image inside it
      const offcanvas = this.closest(".offcanvas");
      const imageElement = offcanvas.querySelector(".the-image");

      // Ensure the corresponding image element exists
      if (imageElement) {
        imageElement.setAttribute("src", imgSrc);
        imageElement.style.opacity = 1;
        imageElement.style.transition = "all 300ms ease-in-out";
      }
    });

    link.addEventListener("mouseleave", function () {
      // Find the closest parent with class 'offcanvas', then find the image inside it
      const offcanvas = this.closest(".offcanvas");
      const imageElement = offcanvas.querySelector(".the-image");

      if (imageElement) {
        imageElement.style.opacity = 0;
      }
    });
  });
});
